export default __webpack_public_path__ + "static/media/CL04.522204a2.mp3";